import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";


const Nylas = ( { aid, uid, meta, tasks, setCurrent } ) => {
    let params = useParams();
    
    
    useEffect( () => {
        document.title = `Third Floor - Email Authentication`;
    }, [] );

    return (
        <div>{params}</div>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Nylas );